// Тусгал (сурагч): өнөөдрийн хичээл бүрийн дараа ойлголт 1–4 + текст. Илгээсэн тусгал нь тухайн хичээлийн ирцэд тооцогдоно.
// Хичээл эхэлснээс хойш тухайн өдрийн 23:59 хүртэл бичиж, засаж болно. Доор — миний сүүлийн тусгалууд.
import React, { useCallback, useEffect, useState } from "react";
import { Button, Input, Spin, message } from "antd";
import { FiCheckCircle, FiClock, FiEdit2 } from "react-icons/fi";
import moment from "moment";
import { instance } from "utils/axios";

const LEVELS = { 1: "Ойлгоогүй", 2: "Хэсэгчлэн ойлгосон", 3: "Ойлгосон", 4: "Бүрэн ойлгосон" };
const LEVEL_CLS = {
  1: "border-red-300 bg-red-50 text-red-700",
  2: "border-amber-300 bg-amber-50 text-amber-800",
  3: "border-sky-300 bg-sky-50 text-sky-800",
  4: "border-emerald-300 bg-emerald-50 text-emerald-700",
};
const req = (method, url, data) => instance({ method, url, data, silent: true }).then((r) => r.data);

// 1–4 ойлголт сонгох том товчнууд
function LevelPicker({ value, onChange, levels }) {
  return (
    <div className="grid grid-cols-4 gap-2" role="radiogroup" aria-label="Ойлголт">
      {[1, 2, 3, 4].map((n) => {
        const on = value === n;
        return (
          <button key={n} type="button" role="radio" aria-checked={on} onClick={() => onChange(n)}
            className={`flex flex-col items-center justify-center gap-0.5 rounded-xl border-2 px-1 py-2.5 min-h-[64px] transition-colors ${on ? LEVEL_CLS[n] : "border-gray-200 bg-white text-gray-600 hover:border-gray-300"}`}>
            <span className="text-lg font-bold leading-none">{n}</span>
            <span className="text-[11px] leading-tight text-center">{levels[n]}</span>
          </button>
        );
      })}
    </div>
  );
}

function LessonCard({ l, levels, minText, onSaved }) {
  const r = l.reflection;
  const [editing, setEditing] = useState(false);
  const [level, setLevel] = useState(r?.understanding || null);
  const [text, setText] = useState(r?.text || "");
  const [saving, setSaving] = useState(false);
  const tooShort = text.trim().length < minText;

  const submit = async () => {
    setSaving(true);
    try {
      const d = await req("post", "/student/reflections", { courseId: l.courseId, period: l.period, understanding: level, text: text.trim() });
      message.success(d.created ? "Тусгал илгээгдлээ · ирцэд тооцогдлоо" : "Тусгал засагдлаа");
      setEditing(false);
      onSaved();
    } catch (e) {
      // алдааг axios interceptor харуулна
    } finally {
      setSaving(false);
    }
  };

  const showForm = l.canWrite && (!r || editing);
  return (
    <section className="pcard pcard-pad flex flex-col gap-3">
      <div className="flex items-start gap-3">
        <span className="h-10 w-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center font-bold shrink-0">{l.period}</span>
        <div className="flex-1 min-w-0">
          <div className="text-[15px] font-bold text-gray-900 leading-snug">{l.course}</div>
          <div className="text-xs text-gray-500 mt-0.5">
            {l.start && `${l.start}–${l.end}`}{l.room ? ` · ${l.room}` : ""}{l.teacher ? ` · ${l.teacher}` : ""}
          </div>
        </div>
        {r && !editing && (
          <span className="inline-flex items-center gap-1 text-xs font-semibold rounded-full px-2 py-0.5 bg-emerald-50 text-emerald-700 shrink-0">
            <FiCheckCircle size={12} /> Илгээсэн
          </span>
        )}
      </div>

      {!l.canWrite && !r && (
        <div className="flex items-center gap-2 text-sm text-gray-400"><FiClock size={14} /> Хичээл {l.start}-д эхэлсний дараа бичнэ</div>
      )}

      {r && !editing && (
        <div className="flex flex-col gap-2">
          <span className={`self-start text-xs font-semibold rounded-full border px-2.5 py-0.5 ${LEVEL_CLS[r.understanding]}`}>
            {r.understanding} · {levels[r.understanding]}
          </span>
          <p className="text-sm text-gray-800 whitespace-pre-wrap m-0">{r.text}</p>
          <div className="flex items-center justify-between gap-2">
            <span className="text-xs text-emerald-700">Илгээсэн · ирцэд тооцогдсон</span>
            {l.canWrite && (
              <Button size="small" icon={<FiEdit2 size={12} />} onClick={() => { setLevel(r.understanding); setText(r.text); setEditing(true); }}>Засах</Button>
            )}
          </div>
        </div>
      )}

      {showForm && (
        <div className="flex flex-col gap-3">
          <div>
            <div className="text-xs font-semibold text-gray-500 mb-1.5">Ойлголт</div>
            <LevelPicker value={level} onChange={setLevel} levels={levels} />
          </div>
          <div>
            <div className="text-xs font-semibold text-gray-500 mb-1.5">Тусгал</div>
            <Input.TextArea value={text} onChange={(e) => setText(e.target.value)} autoSize={{ minRows: 3, maxRows: 10 }} maxLength={5000}
              placeholder="Өнөөдөр юу сурсан, юу ойлгомжгүй байсан бэ?" />
            {tooShort && text.length > 0 && <div className="text-xs text-gray-400 mt-1">Дор хаяж {minText} тэмдэгт</div>}
          </div>
          <div className="flex gap-2">
            {editing && <Button onClick={() => setEditing(false)} className="flex-1">Болих</Button>}
            <Button type="primary" block loading={saving} disabled={!level || tooShort} onClick={submit}
              className="flex-1" style={{ height: 44, fontWeight: 700 }}>
              {editing ? "Хадгалах" : "Илгээх"}
            </Button>
          </div>
        </div>
      )}
    </section>
  );
}

export default function Reflections() {
  const [today, setToday] = useState(null);
  const [past, setPast] = useState(null);

  const load = useCallback(() => {
    req("get", "/student/reflections/today").then(setToday).catch(() => setToday({ lessons: [] }));
    req("get", "/student/reflections").then((d) => setPast(d.reflections || [])).catch(() => setPast([]));
  }, []);
  useEffect(() => { load(); }, [load]);

  const levels = today?.levels || LEVELS;
  const lessons = today?.lessons || [];
  const done = lessons.filter((l) => l.reflection).length;
  const recent = (past || []).filter((r) => r.lessonDate !== today?.date);

  return (
    <div className="pt-4 md:pt-6 pb-6 max-w-3xl mx-auto flex flex-col gap-4">
      <div>
        <h1 className="ptitle">Тусгал</h1>
        <p className="psub">Хичээл бүрийн дараа ойлголтоо үнэлж, тусгалаа бичээрэй. Илгээсэн тусгал ирцэд тооцогдоно.</p>
      </div>

      {!today ? <div className="flex justify-center py-10"><Spin /></div> : (
        <section className="flex flex-col gap-2.5">
          <h2 className="text-base font-bold text-gray-900 mt-1 flex items-center justify-between">
            <span>Өнөөдөр{today.date ? ` · ${moment(today.date).format("MM/DD")}` : ""}</span>
            {lessons.length > 0 && <span className="text-xs font-semibold text-gray-500">{done}/{lessons.length}</span>}
          </h2>
          {!lessons.length ? (
            <div className="pcard pcard-pad text-center py-10 text-gray-400 text-sm">Өнөөдөр хичээл алга</div>
          ) : lessons.map((l) => (
            <LessonCard key={`${l.courseId}-${l.period}-${l.reflection?.updatedAt || ""}`} l={l} levels={levels} minText={today.minText || 10} onSaved={load} />
          ))}
        </section>
      )}

      {recent.length > 0 && (
        <section className="flex flex-col gap-2.5">
          <h2 className="text-base font-bold text-gray-900 mt-1">Сүүлийн тусгалууд</h2>
          {recent.map((r) => (
            <div key={r.id} className="pcard p-3.5 flex flex-col gap-1.5">
              <div className="flex items-center justify-between gap-2">
                <span className="text-sm font-bold text-gray-900 truncate">{r.course}</span>
                <span className="text-xs text-gray-400 shrink-0">{moment(r.lessonDate).format("MM/DD")} · {r.period}-р цаг</span>
              </div>
              <span className={`self-start text-xs font-semibold rounded-full border px-2.5 py-0.5 ${LEVEL_CLS[r.understanding]}`}>
                {r.understanding} · {levels[r.understanding]}
              </span>
              <p className="text-sm text-gray-700 whitespace-pre-wrap m-0">{r.text}</p>
            </div>
          ))}
        </section>
      )}
    </div>
  );
}
